import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=5c2b36e6&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"
import style0 from "./Home.vue?vue&type=style&index=0&id=5c2b36e6&prod&lang=scss&scoped=true&"
import style1 from "./Home.vue?vue&type=style&index=1&id=5c2b36e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b36e6",
  null
  
)

export default component.exports